import React from 'react';
import './App.css';
import PlayerQuery from "./query";

function App() {
  return (
    <div className="App">
      <header className="App-header">
          <PlayerQuery/>
      </header>
    </div>
  );
}

export default App;
